var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Aedu.ResearchInterest = function (superClass) {
  extend(ResearchInterest, superClass);
  function ResearchInterest() {
    return ResearchInterest.__super__.constructor.apply(this, arguments);
  }
  ResearchInterest.prototype.loadFollowersCount = function () {
    return this._loadAsyncAttr('followers_count', $r.api_v0_interest_followers_url({
      interest_id: this.id
    }), function (data) {
      return data.count;
    });
  };
  ResearchInterest.prototype.loadWorksCount = function () {
    return this._loadAsyncAttr('works_count', $r.count_api_v0_interest_works_url({
      interest_id: this.id
    }), function (data) {
      return data.count;
    });
  };
  ResearchInterest.prototype._loadAsyncAttr = function (attr, url, value_from_data) {
    var base, promise;
    this._async_attr_promises || (this._async_attr_promises = {});
    (base = this._async_attr_promises)[attr] || (base[attr] = $.ajax({
      url: url,
      dataType: 'jsonp'
    }));
    promise = new $.Deferred();
    this._async_attr_promises[attr].done(function (data) {
      return promise.resolve(value_from_data(data));
    });
    return promise;
  };
  return ResearchInterest;
}(Backbone.Model);
window.extend = extend;
window.hasProp = hasProp;